/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./SupplierTypeList.scss";
import { withTranslation } from "react-i18next";
import {
  Badge,
  Button,
  Form,
  Modal,
  OverlayTrigger,
  Table,
} from "react-bootstrap";
import { FcFinePrint } from "react-icons/fc";

import {
  BiDownload,
  BiMenuAltRight,
  BiPencil,
  BiSearch,
  BiShareAlt,
  BiPlus
} from "react-icons/bi";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  SORT_ORDER_DESC,
} from "../../../core/constants/common";
import SupplierTypeService from "../../../core/service/SupplierTypeService";
import nodataimg from "../../../images/nodatafound.png";
import Utils from "../../../core/utilities/Utils";
import { toast } from "react-toastify";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import SupplierTypeModal from "../SupplierTypeModal/SupplierTypeModal";
const SupplierTypeList = ({ t }) => {
  var data = JSON.parse(localStorage.getItem("authority"));
  const company = data.profile.company.id;
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [maintabledata, setMainTableData] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeonly, setActiveOnly] = useState(false);

  const [show, setShow] = useState(false);
  const [editid, setEditId] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [editnamevalue, setEditNamevalue] = useState(null);
  const [editstatusvalue, setEditStatusvalue] = useState(true);
  useEffect(() => {
    getMainTableList(0, itemsPerPage, key, sortField, activeonly);
  }, []);
  const getMainTableList = (
    pageNumber,
    itemsPerPageVal,
    key,
    sortField,
    activeOnly
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }

    var sort = sortField + "," + order;
    SupplierTypeService.getList(
      pageNumber,
      perPage,
      key,
      sort,
      company,
      activeOnly
    )
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        const types = response.data;
        types?.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        setMainTableData([...types]);
      })
      .catch((error) => {
      });
  };
  const editData = (item) => {
    setShow(true);
    setEditItem(item);

  };
  const handleClose = () => {
    setEditId(null);
    setEditNamevalue(null);
    setEditStatusvalue(true);
    setShow(false);
  };
  const handleShow = () => {
    setEditItem(null);
    setShow(true);
  };

  const callbackTypeModal = (val) => {
    setShow(false);
    setEditId(null);
    setEditNamevalue(null);
    setEditStatusvalue(true);
    val && getMainTableList(0, itemsPerPage, key, sortField, activeonly);
  };
  const handleSearch = (e) => {
    var searchKey = e.target.value;
    setKey(searchKey);
    getMainTableList(0, itemsPerPage, searchKey, sortField, activeonly);
  };
  return (
    <div className="SupplierTypeList">
      <div className="List_header">
        <h5 className="MH">{t("SupplierTypes.label")}</h5>
        <div className="List_sorts_menu">
          <ul>
            {/* <li>
              <Button variant="secondary" className="">
                <BiDownload /> {t("Import.label")}
              </Button>
            </li> */}
            <li>
              <Button variant="primary" onClick={handleShow}>
                <BiPlus />
                {t("New.label")}
              </Button>
            </li>
          </ul>
        </div>
      </div>

      <div className="List_Table_01">
        <div className="List_table-card01_head">
          <div className="List_table-card_Search_01">
            <div className="List_table-card_Search_Box">
              <Form>
                <input
                  type="text"
                  className="form-control"
                  value={key}
                  onChange={handleSearch}
                  placeholder="Search by Supplier Type"
                />
                <Link to="#" className="Search_iocnBox">
                  <BiSearch />
                </Link>
              </Form>
            </div>
          </div>
          <div className="List_table-card01_sort">
            <ul>
              {/* <li>
                <a href="#">
                  <BiShareAlt /> {t("Share.label")}
                </a>
              </li>
              <li>
                <a href="#">
                  <BiMenuAltRight /> {t("Sort.label")}
                </a>
              </li> */}
              {/* <li className='filter'>
                  <a href='#'><CgSortAz /> {t("Filter.label")}</a>
                </li> */}
            </ul>
          </div>
        </div>
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                {/* <th>
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th> */}
                <th>{t("SupplierType.label")}</th>
                <th>{t("Status.label")}</th>
                <th>{t("Action.label")}</th>
              </tr>
            </thead>
            {(maintabledata === undefined ||
              maintabledata == null ||
              maintabledata.length === 0) && (
                <tbody>
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            {maintabledata &&
              maintabledata !== undefined &&
              maintabledata.length > 0 && (
                <tbody>
                  {maintabledata?.map((item) => (
                    <tr key={item.id}>
                      {/* <td className="checkbox">
                      {" "}
                      <Form.Check
                        inline
                        name="group1"
                        type="checkbox"
                        id="inline-checkbox-1"
                      />
                    </td> */}
                      <td>{item.name}</td>
                      <td>
                        <div>
                          {item.active ? (
                            <Badge bg="badge-Active">{t("Active.label")}</Badge>
                          ) : (
                            <Badge bg="badge-Inactive">{t("Inactive.label")}</Badge>
                          )}
                        </div>
                      </td>
                      <td>
                        <div>
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(t("Edit.label"))}
                          >
                            <span>
                              <BiPencil
                                className="cursor"
                                onClick={() => editData(item)}
                              />
                            </span>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
          </Table>
          <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getMainTableList(pageNum, perPage, key, sortField, activeonly);
              }}
            />
          </div>
        </div>
      </div>
      {show && (
        <SupplierTypeModal isModal={show} item={editItem} callbackModal={callbackTypeModal} />
      )}
    </div>
  );
};

export default withTranslation()(SupplierTypeList);
